import { render } from "./OrderPricePaymentCell.vue?vue&type=template&id=b08e4f88&scoped=true"
import script from "./OrderPricePaymentCell.vue?vue&type=script&lang=js"
export * from "./OrderPricePaymentCell.vue?vue&type=script&lang=js"

import "./OrderPricePaymentCell.vue?vue&type=style&index=0&id=b08e4f88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08e4f88"]])

export default __exports__